






import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "../../../lib/abpbase";
//引入基本模板
let echarts = require("echarts");

// 引入折线图等组件
//require("echarts/lib/chart/line");
// 引入柱状图组件
//require('echarts/lib/chart/bar')
//引入饼图
require('echarts/lib/chart/radar')

// 引入提示框和title组件，图例
require("echarts/lib/component/tooltip");
require("echarts/lib/component/title");
//require('echarts/lib/component/legend')
//require('echarts/lib/component/legendScroll')//图例翻译滚动
@Component
export default class HomeMiddleWareHouses extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  @Prop({type:String}) wseriesdata:string;
  
  
  created() {}
 
  // 指定图表的配置项和数据
  option = {
    title: {
        text: '本月预警次数各库房占比',
        subtext: '单位：次',
        left: 'center'
    },
    tooltip: {
        trigger: 'item'
    },
    legend: {
        orient: 'vertical',
        left: 'left',
    },
    series: [
        {
            name: '预警次数',
            type: 'pie',
            radius: '50%',
             center: ['50%', '50%'],
            roseType: 'area',
            itemStyle: {
                borderRadius: 4
            },
            data: [],
            emphasis: {
                itemStyle: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
            }
        }
    ]
};
  drawLine() {
    //图表
    // 基于准备好的dom，初始化echarts实例
    var myChart = echarts.init(document.getElementById("WareHouse"));

    // 使用刚指定的配置项和数据显示图表。
    myChart.setOption(this.option);
  }
   mounted() {
     //console.log(this.wseriesdata);
     if(this.wseriesdata!=""){
       this.option.series[0].data=JSON.parse(this.wseriesdata);
     }
     this.drawLine();
  }
}
